import { LogicalFieldMixin, RangeLogicalFieldMixin } from './mixins.js';

const LogicalRating = {
  mixins: [
    LogicalFieldMixin,
    RangeLogicalFieldMixin
  ],

  template: `
    <div class="form-field-input">
      <div class="rating-list">
        <div class="rating-item" v-for='num in field.maximum' :key='num'>
          <i class="slp-star-o"></i>
        </div>
      </div>
      <div class="options logic-options">
        <range-logic-option v-for='option in logicSettings'
                            :editing='editing'
                            :limitMax='field.maximum'
                            :logic='option'
                            :controlableFields='controlableFields'
                            :possibleFields='possibleFields'
                            :logicable='logicable'
                            ref='rangeOptions'
                            @childAdded='addChildFunc'
                            @editingChanged='changeEditingStatus'
                            @removeLogic='removeLogic'
                            @updateSetting='updateLogicSetting' />
      </div>
      <div class="field-input-footer">
        <button class="text-btn" v-show='editing' @click='addLogic'>添加逻辑</button>
      </div>
    </div>
  `
};

export default LogicalRating;
